import type { BaseQueryFn } from '@reduxjs/toolkit/query/react';

import { newsScritturaOra } from '@/lib/newsScritturaOra';

/**
 * Il testo dell'errore che una scrittura bloccata restituisce. Esplicito, come `ERRORE_OSPITE`: chi lo legge deve capire che
 * e' una scelta di build, non la rete.
 */
export const ERRORE_NEWS_SCRITTURA =
  'news: questa build non scrive su QNews di produzione (lib/newsScrittura.ts)';

/** I soli metodi che non cambiano nulla sul server. Tutto il resto (POST, PUT, PATCH, DELETE, uno nuovo) e' una scrittura. */
const METODI_DI_LETTURA = new Set(['GET', 'HEAD']);

const eUnaScrittura = (args: unknown): boolean => {
  if (typeof args === 'string') return false; // `query: () => '/x'` e' una GET
  const metodo = (args as { method?: string } | null)?.method;
  return metodo !== undefined && !METODI_DI_LETTURA.has(metodo.toUpperCase());
};

/**
 * 🔴 IL CANCELLO DELLE SCRITTURE DI QNEWS — uno solo, sul client, e sta QUI e non nelle schermate (tma-orcr-85).
 *
 * Ogni mutation di `newsApi` passa da qui: la prossima che si aggiunge e' coperta senza che qualcuno ci pensi. Una scrittura
 * che la regola (`newsScritturaConsentita`) non consente NON tocca la rete: torna un `CUSTOM_ERROR`, subito. Le letture
 * passano identiche (le letture da produzione restano, e' un'altra decisione).
 * ⚠️ Sta FUORI da `guardiaOspite` e fuori da `retry(...)`, di proposito: una richiesta bloccata non va ritentata, e nessun
 * altro strato deve poterla vedere. In produzione la regola vale sempre `true`: la guardia non cambia nessuna risposta.
 */
export function guardiaScritturaNews<BQ extends BaseQueryFn>(baseQuery: BQ): BQ {
  const guardato = (async (args, api, extraOptions) => {
    if (eUnaScrittura(args) && !newsScritturaOra()) {
      return { error: { status: 'CUSTOM_ERROR', error: ERRORE_NEWS_SCRITTURA } };
    }
    return baseQuery(args, api, extraOptions);
  }) as BaseQueryFn as unknown as BQ;
  return guardato;
}
